export default "__VITE_ASSET___5K8GHN0__"